import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MainPanelModule } from '../main-panel/main-panel.component';
import { ReportComponent } from './report.component';
import { DatepickerModule } from 'src/app/sharing-module/datepicker/datepicker.component';
import { ChartReportComponent } from './chart-report/chart-report.component';
import { PieChartModule } from 'src/app/sharing-module/pie-chart/pie-chart.component';
import { ComplexPaginationModule } from 'src/app/sharing-module/complex-pagination/complex-pagination.component';
import { ProductReportComponent } from './product-report/product-report.component';
import { ProductReportService } from './product-report/product-report.service';
import {MatSortModule} from '@angular/material/sort';

export const pageData = {
  N: {
    TM: [
      {
        T: 'Sales',
        U: 'report/list',
      },
      {
        T: 'Chart',
        U: 'report/pie-chart',
      },
      {
        T: 'Product',
        U: 'report/product',
      },
    ],
  },
};
const routes: Routes = [
  { path: '', redirectTo: 'list', pathMatch: 'full' },
  { path: 'list', component: ReportComponent },
  { path: 'pie-chart', component: ChartReportComponent },
  { path: 'product', component: ProductReportComponent },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MainPanelModule,
    DatepickerModule,
    PieChartModule,
    ComplexPaginationModule,
    MatSortModule,
    RouterModule.forChild(routes),
  ],
  declarations: [ReportComponent, ChartReportComponent, ProductReportComponent],
  providers: [
    ProductReportService
  ]
})
export class ReportModule {}
